<template>
  <v-layout fill-height>
    <v-card tile flat class="d-flex justify-center align-center flex-column"
        height="360px"
        width="100%">
        <v-icon class="mb-2 black--text">{{ opts.icon }}</v-icon>
        <div>{{ opts.title }}</div>
        <v-btn depressed outlined small
            color="accent"
            class="mt-5"
            v-if="opts.showBtn"
            @click.prevent="onAction"
        >{{ opts.btnText }}</v-btn>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  data() {
    return {
      defaults: {
        title: 'No results',
        icon: 'mdi-flask-empty-remove-outline',
        showBtn: false,
        btnText: 'Add',
      },
    };
  },
  computed: {
    opts() {
      return {
        ...this.defaults,
        ...this.options,
      };
    },
  },
  methods: {
    onAction() {
      this.$emit('action');
    },
  },
};
</script>
